import LectureLessonStatusListResultModelBase from '../_generated/modelBases/lecture-lesson-status-list-result-model-base';

export default class LectureLessonStatusListResultModel extends LectureLessonStatusListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
